import { SvgIcon, SvgIconProps } from "@mui/material"
import React from "react"

const MailFillIcon: React.FC<SvgIconProps> = ({fill, ...props}) => {
  return (
    <SvgIcon width='24' height='24' viewBox="0 0 24 24" sx={{fill: 'transparent'}} {...props}>
      <path fill={fill ?? "#F3F4F6"} d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z" />
    </SvgIcon>
  )
}

export default MailFillIcon